import { render, staticRenderFns } from "./PublisherSelect.vue?vue&type=template&id=2a23c87e&scoped=true"
import script from "./PublisherSelect.vue?vue&type=script&lang=js"
export * from "./PublisherSelect.vue?vue&type=script&lang=js"
import style0 from "./PublisherSelect.vue?vue&type=style&index=0&id=2a23c87e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a23c87e",
  null
  
)

export default component.exports